import { render, staticRenderFns } from "./NavbarMain.vue?vue&type=template&id=4ecd4d0b&"
import script from "./NavbarMain.vue?vue&type=script&lang=js&"
export * from "./NavbarMain.vue?vue&type=script&lang=js&"
import style0 from "./NavbarMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports